import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { ChangelogService } from '@app/core/api/changelog.service';
import { ChangelogSeenService } from '@app/core/state/changelogseen/changelogseen.service';
import { StaticPathUtil } from '@app/core/util/static-path.util';
import { ClVersion } from '@app/shared/changelog/version/clversion.model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NgIf, NgFor } from '@angular/common';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { ClVersionComponent } from './version/cl-version.component';
import { MatButton } from '@angular/material/button';

@UntilDestroy()
@Component({
  selector:        'app-changelogoverlay',
  templateUrl:     './changelogoverlay.component.html',
  styleUrls:       ['./changelogoverlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone:      true,
  imports:         [
    MatDialogTitle,
    NgIf,
    NgFor,
    CdkScrollable,
    MatDialogContent,
    ClVersionComponent,
    MatDialogActions,
    MatButton,
    MatDialogClose
  ]
})
export class ChangelogOverlayComponent implements OnInit {
  readonly MAX_RESULTS: number = 7;
  versions: ClVersion[];
  isOverlayOpen = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: boolean, public staticPath: StaticPathUtil,
              private dialogRef: MatDialogRef<ChangelogOverlayComponent>,
              private changelogService: ChangelogService, private changelogSeenService: ChangelogSeenService,
  ) {
  }

  ngOnInit(): void {
    this.changelogService.versionsChanged.pipe(untilDestroyed(this)).subscribe(
      (versions: ClVersion[]) => {
        this.versions = versions;
      });

    this.changelogService.getVersions(this.MAX_RESULTS).subscribe(() => {
      if(this.versions.length>0) {
        this.onVersionClick(0);
      }
    });
  }

  onVersionClick(version: number) {
    this.changelogSeenService.setViewedVersions(this.versions[version].title);
    this.versions[version].seen = true;
    this.changelogService.checkVersions(this.versions);
    this.changelogService.clickedVersion.next(version);
  }

  public toggleOverlay(): void {
    this.isOverlayOpen = !this.isOverlayOpen;
  }

  isVersionSeen(version: ClVersion) {
    return this.changelogSeenService.isVersionSeen(version.title);
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }
}
